import React, { useState } from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import {
  Home as HomeIcon,
  History as OrderHistoryIcon,
  Analytics as AnalyticsIcon,
  AttachMoney as EarningsIcon,
  Person as ProfileIcon,
  Settings as SettingsIcon,
  Help as HelpIcon,
  Logout as LogoutIcon,
  PriceChange as RateCardIcon,
  Chat as ChatIcon
} from "@mui/icons-material";

const LayoutContainer = styled.div`
  font-family: "poppins";
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

const Content = styled.div`
  width: 98%;
  display: flex;
  gap: 24px;
`;

const MainContent = styled.div`
  width: 100%;
  height: calc(100vh - 104px);
  padding: 0;
`;

const menuItems = [
  { name: "Work List", icon: <HomeIcon />, path: "/dashboard" },
  { name: "Order History", icon: <OrderHistoryIcon />, path: "/order-history" },
  { name: "Analytics", icon: <AnalyticsIcon />, path: "/analytics" },
  { name: "Earnings", icon: <EarningsIcon />, path: "/earnings" },
  { name: "Rate Card", icon: <RateCardIcon />, path: "/rate-card" },
  { name: "Messages", icon: <ChatIcon />, path: "/chat" },
];

const settingsItems = [
  { name: "Profile", icon: <ProfileIcon />, path: "/profile" },
  { name: "Settings", icon: <SettingsIcon />, path: "/settings" },
  { name: "Help", icon: <HelpIcon />, path: "/help" },
  { name: "Logout", icon: <LogoutIcon />, path: "/logout" },
];

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <LayoutContainer>
      <Navbar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        title="Dashboard"
      />
      <Content>
        <Sidebar
          menuItems={menuItems}
          settingsItems={settingsItems}
          isSidebarOpen={isSidebarOpen}
        />
        <MainContent>
          <Outlet />
        </MainContent>
      </Content>
    </LayoutContainer>
  );
};

export default MainLayout; 